<template>
    <div class="icon-mountain"></div>
</template>